import { Box, Button, Flex, IconFont, Select, Tooltip } from '@byecode/ui'
import type { DataSourceAbstract } from '@lighthouse/core'
import { FieldTypeTag, getFieldOptions, SORT_OPTIONS } from '@lighthouse/shared'
import { nanoid } from '@lighthouse/tools'
import React, { useMemo } from 'react'
import { Controller, useFieldArray, useFormContext } from 'react-hook-form'

import type { PageVariableFormSlice } from '../../../formSlice'
import * as SC from './styles'

interface SortConfigureProps {
    dataSource: DataSourceAbstract
}
export const SortConfigure = ({ dataSource }: SortConfigureProps) => {
    const { control } = useFormContext<PageVariableFormSlice>()

    const { fields, append, remove } = useFieldArray({ control, name: 'sorts', keyName: 'key' })

    const { schema, viewOptions: { tableProps = [] } = {} } = dataSource || {}
    const fieldOptions = useMemo(() => {
        return getFieldOptions(schema, tableProps).map(item => ({
            ...item,
            extra: <FieldTypeTag type={item.type} innerType={item.innerType} />
        }))
    }, [schema, tableProps])

    return (
        <Box>
            <SC.FormItemHeader>
                <Flex alignItems="center" gap={4}>
                    <SC.FormLabel>排序规则</SC.FormLabel>
                    <Tooltip
                        width={192}
                        title="当查找到多个记录时，将按照以下排序规则获得第一条记录。如果未设置规则，返回最近更新的一条记录"
                    >
                        <IconFont type="Question" fill="var(--color-gray-400)" />
                    </Tooltip>
                </Flex>
            </SC.FormItemHeader>
            <Flex py={8} direction="column" gap={8}>
                {fields.map((item, index) => (
                    <Flex key={item.id} gap={8} alignItems="center">
                        <Controller
                            control={control}
                            name={`sorts.${index}.fieldId`}
                            render={({ field }) => <Select {...field} options={fieldOptions} size="lg" searchable style={{ flex: 1 }} />}
                        />
                        <Controller
                            control={control}
                            name={`sorts.${index}.order`}
                            render={({ field }) => <Select {...field} options={SORT_OPTIONS} size="lg" style={{ flex: 1 }} />}
                        />
                        <SC.DeleteButton onClick={() => remove(index)}>
                            <IconFont type="Close" />
                        </SC.DeleteButton>
                    </Flex>
                ))}

                <Button
                    style={{ alignSelf: 'flex-start' }}
                    radius={100}
                    icon={<IconFont type="Add" fill="var(--color-gray-500)" />}
                    onClick={() => {
                        append({ id: nanoid(), fieldId: fieldOptions[0]?.value || '', order: 'ASC' }, { shouldFocus: false })
                    }}
                >
                    添加
                </Button>
            </Flex>
        </Box>
    )
}
